// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { ILocationSearchResult } from '~/misc/location/search/types';
import { ESearchResultType } from '~/misc/location/search/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerLocationSearchModel extends ManagerResource {
  protected endpoint = 'location-search/';

  search(
    query: string,
    include: ESearchResultType[] = [ESearchResultType.DISTRICT, ESearchResultType.SECTOR],
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<ILocationSearchResult[]> {
    return this.get<ILocationSearchResult[]>(`search/${query}`, { include }, requestConfig);
  }
}
